export default class GlobalValue {
  static BASE_URL = "http://14.63.172.72:8080/TESTDP/rest/";
  static BASE_URL2 = "http://1.246.219.187:5000/";
  // static BASE_URL2 = "http://localhost:5000/";
  static PICTURE_URL = "http://14.63.172.72:8080";
  // static BASE_URL = "http://linepayroll.iptime.org:8080/TESTDP/rest/";
  // static PICTURE_URL = "http://linepayroll.iptime.org:8080"
  // static BASE_URL = "http://192.168.0.51:8080/rest/";
  // static APP_VERSION = "20181212.01"
  // static APP_VERSION = "1.0.13";
  static USER_INFO;
  static jijum = [];
  static jikcheck = [];
  static country = [];
  static buseo = [];
  static stay = [];
  static fcmToken;
  static mjijum = [];
  static workType = [];
  static VERSION = 0;
  static isUser;
  static SUMyPicYN;
  static MyPicURL;
  static ststate = [{ name: "재직", code: 0 }, { name: "퇴직", code: 2 }];
  static isManager; // 월별근태확정 가능자 ? 1005이하
  static isNoSTCode;

  static EG1Code_0 = [
    { name: "구분", value: 0 },
    { name: "인사", value: 100 },
    { name: "업무", value: 101 },
    { name: "총무", value: 102 }
  ];
  static EG1Code_1 = [
    { name: "구분", value: 0 },
    { name: "업무", value: 200 }
    // { name: "공지", value: 201 }
  ];
  static EG1Code_2 = [
    { name: "구분", value: 0 },
    { name: "교부", value: 300 },
    { name: "동의", value: 301 },
    { name: "공지", value: 302 },
    { name: "인사", value: 100 },
    { name: "업무", value: 101 },
    { name: "총무", value: 102 },
    { name: "업무", value: 200 }
  ];
  static EG1Code_2_l = [
    { name: "구분", value: 0 },
    { name: "교부", value: 300 },
    // { name: "동의", value: 301 },
    { name: "공지", value: 302 }
  ];
  static EG1Code_0_insa = [
    { name: "항목", value: 0 },
    { name: "근태 시간 정정", value: 1 },
    { name: "연차 휴가 신청", value: 2 },
    { name: "연장 근로 신청", value: 3 }
  ];
  static EG1Code_0_insa_inoutTime = [
    { name: "항목", value: 0 },
    { name: "출근 시간", value: "00" },
    { name: "퇴근 시간", value: "01" },
    { name: "출/퇴근 시간", value: "02" }
  ];
  static EJSignGubun_0 = [
    { name: "구분", value: 0 },
    { name: "대기", value: 1 },
    { name: "보완", value: 2 },
    { name: "반려", value: 3 },
    { name: "상신", value: 4 },
    { name: "최종승인", value: 5 }
  ];
  static EJSignGubun_1 = [
    { name: "구분", value: 0 },
    { name: "대기", value: 1 },
    { name: "진행예정", value: 6 },
    { name: "진행중", value: 7 },
    { name: "완료", value: 8 }
    // { name: "최종승인", value: 5 }
  ];
  static EJSignGubun_2 = [
    { name: "구분", value: 0 },
    { name: "대기", value: 1 },
    { name: "보완", value: 2 },
    { name: "반려", value: 3 },
    { name: "상신", value: 4 },
    { name: "최종승인", value: 5 },
    { name: "진행중", value: 7 },
    { name: "열람", value: 9 },
    { name: "동의", value: 10 },
    { name: "완료", value: 8 }
  ];
  // static EJSignGubun_2= [{ name: "대기", value: 1 }, { name: "보완", value: 2 }, { name: "반려", value: 3 }, { name: "상신", value: 4 }, { name: "최종승인", value: 5 }]
}
